/* Hairmosa — fiche produit tissage. Custom element <hm-produit>, vanilla, sans dépendance.
   Données et textes : <script type="application/json" data-hm-donnees> généré en Liquid. */
(() => {
  'use strict';
  if (window.customElements.get('hm-produit')) return;

  const $ = (root, sel) => root.querySelector(sel);
  const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));
  const num = (v) => parseFloat(String(v ?? '').replace(',', '.')) || 0;
  const tpl = (t, vars) => String(t ?? '').replace(/\[(\w+)\]/g, (m, k) => (k in vars ? vars[k] : m));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const racine = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const emit = (nom, detail) => document.documentElement.dispatchEvent(new CustomEvent(nom, { bubbles: true, detail }));

  /* Réduit la taille de police des éléments fournis par pas de 0,5 px, du même facteur pour tous,
     jusqu'à ce que `tient()` soit vrai ou que le plancher soit atteint ; sert aux étiquettes
     (.hm-tags) et à l'aide « Closure conseillée » (.hm-aide-longueur-closure). */
  function ajusterTailleAuto(items, tient, { depart = 13, plancher = 10 } = {}) {
    let taille = depart, ok = false;
    while (taille >= plancher) {
      items.forEach((el) => { el.style.fontSize = `${taille}px`; });
      ok = tient();
      if (ok) break;
      taille -= 0.5;
    }
    if (!ok) items.forEach((el) => { el.style.fontSize = `${plancher}px`; });
    return taille;
  }

  /* Étiquettes (.hm-tags) : chaque étiquette garde sa largeur naturelle, seulement si leur somme
     (+ espaces) dépasse la largeur disponible du conteneur ; le padding en em suit la taille. */
  function ajusterTailleEtiquettes(ul) {
    const items = Array.from(ul.children);
    if (!items.length) return;
    const gap = parseFloat(getComputedStyle(ul).columnGap) || 0;
    ajusterTailleAuto(items, () => {
      const total = items.reduce((s, li) => s + li.scrollWidth, 0) + gap * (items.length - 1);
      return total <= ul.clientWidth + 1;
    });
  }

  /* « Closure conseillée » (.hm-aide-longueur-closure) : la phrase entière tient sur une seule
     ligne (white-space: nowrap en CSS) ; si elle ne tient toujours pas au plancher, elle se coupe
     avec des points de suspension (text-overflow: ellipsis, en CSS). */
  function ajusterTailleClosure(p) {
    ajusterTailleAuto([p], () => p.scrollWidth <= p.clientWidth + 1, { depart: 13.5 });
  }

  /* Date de livraison : calcul et table des délais par produit dans assets/hm-livraison.js
     (window.HMLivraison, chargé avant ce script), source unique partagée avec la fiche perruque
     et le quiz. */

  /* Choisit, parmi les sources MP4 fournies par Shopify (video.sources), la plus légère dont la
     hauteur couvre la hauteur affichée × densité de pixels — plafonnée à 720p sous 900px de large
     (jamais de 1080p sur mobile). Sans correspondance : la plus grande disponible sous ce plafond. */
  function choisirSourceMp4(sources, hauteurAffichee) {
    let mp4 = (sources || []).filter((s) => /mp4/i.test(s.type || '') && num(s.height) > 0);
    if (!mp4.length) return null;
    if (window.innerWidth < 900) {
      const plafonnees = mp4.filter((s) => num(s.height) <= 720);
      if (plafonnees.length) mp4 = plafonnees;
    }
    mp4.sort((a, b) => num(a.height) - num(b.height));
    const cible = hauteurAffichee * (window.devicePixelRatio || 1);
    return mp4.find((s) => num(s.height) >= cible) || mp4[mp4.length - 1];
  }

  /* Format monétaire de la boutique (mêmes règles que Shopify.formatMoney), sans jamais arrondir
     le montant : les décimales sont juste masquées quand elles sont nulles ("599 €" plutôt que
     "599,00 €"), affichées sinon ("284,50 €" reste "284,50 €") — même règle que le filtre Liquid
     money_without_trailing_zeros, cote serveur. Espace insécable entre le montant et le symbole :
     le format de la boutique ({{amount}}€) n'en a pas nativement. */
  function money(cents, format) {
    const f = String(format), k = (f.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    const mil = k.includes('comma_separator') ? '.' : k.includes('space') ? ' ' : k.includes('apostrophe') ? "'" : ',';
    const sep = k.includes('comma_separator') || k.includes('with_space') ? ',' : '.';
    let [i, d] = (Math.round(cents) / 100).toFixed(k.includes('no_decimals') ? 0 : 2).split('.');
    i = i.replace(/\B(?=(\d{3})+(?!\d))/g, mil);
    const montant = d && d !== '00' ? i + sep + d : i;
    return f.replace(/\{\{.*?\}\}/, montant).replace(/<[^>]+>/g, '').trim()
      .replace(/(\d)\s*(\D)$/, '$1 $2').replace(/^(\D)\s*(\d)/, '$1 $2');
  }

  class HmProduit extends HTMLElement {
    connectedCallback() {
      const json = $(this, '[data-hm-donnees]');
      this.form = $(this, 'form[action*="/cart/add"]');
      if (!json || !this.form) return;
      this.d = JSON.parse(json.textContent);
      this.t = this.d.textes;
      this.r = this.d.reglages;
      this.el = {};
      ['id', 'cta', 'cta-texte', 'cta-prix', 'echeances', 'badge', 'badge-texte', 'eco', 'eco-texte', 'point-dispo', 'dispo-texte', 'dispo', 'dispo-epuise', 'erreur',
        'visuel', 'photo', 'ap-long', 'ap-cm', 'repere', 'mbv', 'puces', 'options', 'tags',
        'closure-options', 'closure-prix-choix', 'aide-closure-valeur', 'aide-closure-suite', 'aide-longueur-closure', 'tailles', 'ferme', 'lace',
        'collante', 'collante-prix', 'collante-detail', 'collante-eco', 'collante-eco-texte', 'collante-texte', 'collante-btn', 'piste', 'points', 'vignettes'
      ].forEach((k) => { this.el[k] = $(this, `[data-hm-${k}]`); });

      this.qteChoisie = false;
      this.closureLongueurChoisie = false;
      const svgSilhouette = this.el.visuel && $(this.el.visuel, '.hm-silhouette');
      this.silhouette = svgSilhouette ? new window.HMIllustrations.Silhouette(svgSilhouette, { longueur: this.longueur }) : null;
      const svgLace = this.el.lace && $(this.el.lace, '.hm-schema-closure');
      this.schemaClosure = svgLace ? new window.HMIllustrations.SchemaClosure(svgLace, { format: this.taille }) : null;
      /* Mode Closure, produit sans image : le schéma en grand tient lieu de visuel principal. */
      const svgLaceGalerie = $(this, '[data-hm-galerie-schema] .hm-schema-closure');
      this.schemaClosureGalerie = svgLaceGalerie ? new window.HMIllustrations.SchemaClosure(svgLaceGalerie, { format: this.taille }) : null;

      this.form.addEventListener('change', (e) => this.onChange(e));
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      const guideCta = $(document, '[data-hm-guide-cta]');
      if (guideCta) guideCta.addEventListener('click', (e) => this.onSubmit(e));
      this.dates();
      this.galerie();
      this.collante();
      this.etiquettes();
      this.closureConseillee();
      this.rendre();
      requestAnimationFrame(() => {
        const c = $(this, 'input[name="hm-longueur"]:checked');
        if (c && this.el.puces) this.el.puces.scrollLeft = c.parentElement.offsetLeft - this.el.puces.clientWidth / 2 + c.parentElement.clientWidth / 2;
      });
    }

    /* ---------- État ---------- */
    get longueurInput() { return $(this, 'input[name="hm-longueur"]:checked'); }
    get longueur() { return num(this.longueurInput?.value); }
    get densite() { return $(this, 'input[name="hm-densite"]:checked')?.value || this.r.densiteDefaut; }
    get qte() { return num($(this, 'input[name="hm-paquets"]:checked')?.value) || 1; }
    get ferme() { return !!this.el.ferme && this.el.ferme.checked; }
    get taille() { return $(this, 'input[name="hm-taille"]:checked')?.value; }
    get closureLongueur() { return num($(this, 'input[name="hm-longueur-closure"]:checked')?.value); }
    mot(n) { return n > 1 ? this.t.paquetPluriel : this.t.paquetSingulier; }
    money(c) { return money(c, this.r.moneyFormat); }

    /* Une seule source de vérité : le bloc de longueur choisie (settings paquets_recommandes,
       paquets_volume, closure_longueur_recommandee). Sans bloc correspondant : aucune recommandation. */
    repereData(l) { return (this.d.reperes || []).find((x) => num(x.longueur) === l) || null; }
    reco(l) {
      const r = this.repereData(l);
      if (!r) return 0;
      if (this.r.afficherDensite) {
        const cle = this.densite === 'fins' ? 'paquetsFins' : this.densite === 'epais' ? 'paquetsEpais' : 'paquetsMoyens';
        return num(r[cle]) > 0 ? num(r[cle]) : 0;
      }
      return num(r.paquetsRecommandes) > 0 ? num(r.paquetsRecommandes) : 0;
    }
    volume(l) { const r = this.repereData(l); return r && num(r.paquetsVolume) > 0 ? num(r.paquetsVolume) : 0; }
    closureCible(l) { const r = this.repereData(l); return r && num(r.closureLongueurRecommandee) > 0 ? num(r.closureLongueurRecommandee) : l; }

    variantMeches(longueur, n) {
      return (this.d.variantesMeches || []).find((v) => v.longueur === longueur && v.paquets === n) || null;
    }

    variantClosure(taille, longueurClosure) {
      const c = this.d.closure;
      if (!c) return null;
      return c.variantes.find((v) => v.options[c.idxTaille] === taille && (c.idxLongueur < 0 || num(v.options[c.idxLongueur]) === longueurClosure)) || null;
    }

    /* Applique la longueur de closure recommandée : valeur du bloc de longueur choisie, sinon la
       plus grande longueur de closure disponible inférieure ou égale à la longueur des mèches. */
    appliquerClosureRecommandee() {
      const radios = $$(this, 'input[name="hm-longueur-closure"]');
      if (!radios.length) return;
      const cible = this.closureCible(this.longueur);
      let meilleur = null;
      radios.forEach((r) => { if (num(r.value) <= cible && (!meilleur || num(r.value) > num(meilleur.value))) meilleur = r; });
      if (!meilleur) meilleur = radios.reduce((a, r) => (!a || num(r.value) < num(a.value) ? r : a), null);
      if (meilleur) meilleur.checked = true;
    }

    onChange(e) {
      const n = e.target.name;
      if (n === 'hm-longueur') {
        if (!this.qteChoisie) { const r = $(this, `input[name="hm-paquets"][value="${this.reco(this.longueur)}"]`); if (r) r.checked = true; }
        if (!this.closureLongueurChoisie) this.appliquerClosureRecommandee();
        document.dispatchEvent(new CustomEvent('hm:longueur', { bubbles: true, detail: { longueur: this.longueur } }));
      }
      if (n === 'hm-densite') {
        if (!this.qteChoisie) { const r = $(this, `input[name="hm-paquets"][value="${this.reco(this.longueur)}"]`); if (r) r.checked = true; }
      }
      if (n === 'hm-paquets') this.qteChoisie = true;
      if (n === 'hm-type' && e.target.value === 'ferme' && !this.closureLongueurChoisie) this.appliquerClosureRecommandee();
      if (n === 'hm-longueur-closure') this.closureLongueurChoisie = true;
      this.rendre();
    }

    /* ---------- Rendu (mode Closure) : le produit a ses propres options Format × Taille, sans
       paquets ni closure liée. Réutilise les getters taille (radios name="hm-taille" : Format,
       mêmes classes que le sélecteur de format de la closure liée) et longueur (radios
       name="hm-longueur" : Taille). Isolé de rendre() pour ne rien changer au mode Tissage. ---------- */
    rendreClosureProduit() {
      const t = this.t;
      const variantes = this.d.varianteFormat || [];
      const trouver = (format, taille) => variantes.find((v) => v.format === format && v.taille === taille) || null;

      $$(this, 'input[name="hm-longueur"]').forEach((r) => {
        const dispo = variantes.some((v) => v.taille === num(r.value) && v.disponible);
        r.disabled = !dispo;
        r.toggleAttribute('data-epuise', !dispo);
        const span = r.nextElementSibling, small = span && $(span, 'small');
        if (!dispo && span && !small) span.insertAdjacentHTML('beforeend', `<small>${esc(t.epuise)}</small>`);
        if (dispo && small) small.remove();
      });
      const longueursDispo = $$(this, 'input[name="hm-longueur"]').filter((r) => !r.disabled);
      if (longueursDispo.length && !longueursDispo.some((r) => r.checked)) longueursDispo[0].checked = true;
      const l = this.longueur;

      $$(this, 'input[name="hm-taille"]').forEach((r) => {
        const v = trouver(r.value, l), ok = !!(v && v.disponible);
        r.disabled = !ok;
        const span = r.nextElementSibling, prixEl = span && $(span, '[data-hm-format-prix]');
        if (prixEl) prixEl.textContent = v ? this.money(num(v.prix)) : t.indisponible;
      });
      const formatsDispo = $$(this, 'input[name="hm-taille"]').filter((r) => !r.disabled);
      if (formatsDispo.length && !formatsDispo.some((r) => r.checked)) formatsDispo[0].checked = true;
      const format = this.taille;

      this.majSchemaLace(format);
      if (this.schemaClosureGalerie) this.schemaClosureGalerie.afficher(format);

      const vSel = trouver(format, l);
      this.vSelClosure = vSel;
      if (vSel) { const u = new URL(location.href); u.searchParams.set('variant', vSel.id); history.replaceState(null, '', u); }

      const total = vSel ? num(vSel.prix) : 0;
      const prixBarre = vSel ? num(vSel.prixBarre) : 0;
      const eco = prixBarre > total ? prixBarre - total : 0;
      const surCommande = !!(vSel && vSel.surCommande);
      const epuise = !vSel || !vSel.disponible;
      if (this.el.dispo) this.el.dispo.hidden = epuise;
      if (this.el['dispo-epuise']) { this.el['dispo-epuise'].hidden = !epuise; this.el['dispo-epuise'].textContent = epuise ? t.epuiseSelection : ''; }
      this.majStatut(surCommande);
      const taux = (window.Shopify && window.Shopify.currency && num(window.Shopify.currency.rate)) || 1;
      const manque = Math.round(this.r.seuil * taux) - total;
      this.el.badge.classList.toggle('is-incitation', manque > 0);
      this.el['badge-texte'].textContent = manque > 0 ? tpl(t.badgeSous, { montant: this.money(manque) }) : t.badgeOfferte;
      if (this.el.eco) this.el.eco.hidden = !(eco > 0);
      if (this.el['eco-texte']) this.el['eco-texte'].textContent = eco > 0 ? tpl(t.pastilleEconomie, { economie: this.money(eco) }) : '';
      this.el['cta-prix'].innerHTML = this.cardPrixHtml(total, prixBarre);
      this.el.echeances.innerHTML = this.echeancesHtml(this.money(Math.round(total / num(this.r.echeances))));
      const vars = { quantite: 1, paquet: this.mot(1), longueur: l, taille: format, montant: this.money(total) };
      if (this.el.collante) {
        this.el['collante-prix'].innerHTML = this.cardPrixHtml(total, prixBarre);
        this.el['collante-detail'].textContent = tpl(t.collanteDetail, vars);
        if (this.el['collante-eco']) this.el['collante-eco'].hidden = !(eco > 0);
        if (this.el['collante-eco-texte']) this.el['collante-eco-texte'].textContent = eco > 0 ? tpl(t.pastilleEconomie, { economie: this.money(eco) }) : '';
      }
      this.el.id.value = vSel ? vSel.id : this.el.id.value;
      this.el.cta.disabled = epuise;
      this.el['cta-texte'].textContent = epuise ? t.boutonEpuise : t.bouton;
      if (this.el['collante-btn']) this.el['collante-btn'].disabled = epuise;
      if (this.el['collante-texte']) this.el['collante-texte'].textContent = epuise ? t.boutonEpuise : t.bouton;
    }

    /* ---------- Rendu ---------- */
    rendre() {
      if (this.r.modeClosure) { this.rendreClosureProduit(); return; }
      const t = this.t, l = this.longueur, li = this.longueurInput, rec = this.reco(l), vol = this.volume(l);
      let qte = this.qte;

      /* Aperçu longueur */
      if (li) {
        this.el['ap-long'].textContent = `${l} ${t.unitePouces}`;
        this.el['ap-cm'].textContent = `${li.dataset.cm} ${t.uniteCm}`;
        const rep = this.repereData(l);
        this.el.repere.textContent = rep ? tpl(t.repere, { repere: rep.texte }) : '';
        this.el.mbv.textContent = l === num(this.r.meilleureVente) ? t.meilleureVente : '';
        if (li.dataset.photo) {
          this.el.photo.src = li.dataset.photo;
          this.el.photo.alt = li.dataset.photoAlt || tpl(t.photoAlt, { produit: this.d.produitTitre, longueur: l });
          this.el.photo.hidden = false;
          this.el.visuel.classList.add('has-photo');
        } else {
          if (this.silhouette) this.silhouette.allerA(l);
          this.el.visuel.classList.remove('has-photo');
          this.el.photo.hidden = true;
        }
      }

      /* Options de quantité : prix lus sur la variante (longueur, n paquets) */
      const rep = this.repereData(l);
      const contenuActif = num(this.r.bandesParPaquet) > 0 && rep && num(rep.poidsPaquet) > 0;
      const dispoN = [];
      $$(this, '[data-hm-option]').forEach((o) => {
        const n = num(o.dataset.hmOption), vm = this.variantMeches(l, n), ok = !!(vm && vm.disponible);
        const input = $(o, 'input'), sousEl = $(o, '[data-hm-option-sous]'), prixEl = $(o, '[data-hm-option-prix]');
        input.disabled = !ok;
        o.classList.toggle('is-indisponible', !ok);
        o.classList.toggle('is-reco', n === rec);
        /* Mode « contenu du paquet » (clip-in) : carte inchangée. Sinon (fiches tissage) : onglet
           « Recommandé pour du [longueur] », économie et prix par paquet. */
        o.classList.toggle('hm-option--detail', !contenuActif);
        const badgeEl = $(o, '.hm-badge-reco');
        if (badgeEl) badgeEl.textContent = contenuActif ? t.badgeReco : tpl(t.badgeRecoLongueur, { longueur: `${l}"` });
        if (ok && contenuActif) {
          dispoN.push(n);
          const sous = tpl(t.contenuPaquet, { bandes: n * num(this.r.bandesParPaquet), poids: n * num(rep.poidsPaquet) });
          sousEl.textContent = sous;
          sousEl.hidden = !sous;
          const remise = vm.prixBarre ? Math.round((1 - vm.prix / vm.prixBarre) * 100) : 0;
          prixEl.innerHTML = `<b>${this.money(vm.prix)}</b>` + (remise ? `<s>${this.money(vm.prixBarre)}</s><span class="hm-remise">${esc(tpl(t.remise, { remise }))}</span>` : '');
        } else if (ok) {
          dispoN.push(n);
          const barre = num(vm.prixBarre) > vm.prix;
          let sous = '';
          if (n === 1) sous = esc(t.aLUnite);
          else if (barre) sous = `<span class="hm-option__ligne">${esc(tpl(t.economieOption, { economie: this.money(vm.prixBarre - vm.prix) }))}</span>`;
          if (vol && n === vol) sous += `<span class="hm-option__ligne">${esc(t.optionVolume)}</span>`;
          sousEl.innerHTML = sous;
          sousEl.hidden = !sous;
          prixEl.innerHTML = `<span class="hm-option__montants"><b>${this.money(vm.prix)}</b>${barre ? ` <s>${this.money(vm.prixBarre)}</s>` : ''}</span>`
            + (n > 1 ? `<span class="hm-option__unitaire">${esc(tpl(t.prixPaquet, { prix: this.money(vm.prix / n) }))}</span>` : '');
        } else {
          sousEl.textContent = '';
          sousEl.hidden = true;
          prixEl.innerHTML = `<b>${esc(t.indisponible)}</b>`;
        }
      });
      if (dispoN.length && !dispoN.includes(qte)) {
        const recoCible = rec || 1;
        const cible = dispoN.includes(recoCible) ? recoCible : dispoN.reduce((a, b) => (Math.abs(b - recoCible) < Math.abs(a - recoCible) ? b : a));
        const r = $(this, `input[name="hm-paquets"][value="${cible}"]`);
        if (r) r.checked = true;
        qte = this.qte;
      }
      const vmSel = this.variantMeches(l, qte);
      if (vmSel || li) {
        const u = new URL(location.href); u.searchParams.set('variant', vmSel ? vmSel.id : li.dataset.id); history.replaceState(null, '', u);
      }

      /* Closure */
      let cv = null, prixClosure = 0, taille = this.taille, closureLongueur = this.closureLongueur;
      if (this.d.closure) {
        const c = this.d.closure;
        const radiosTaille = $$(this, 'input[name="hm-taille"]');
        const radiosLongueur = $$(this, 'input[name="hm-longueur-closure"]');
        const tailleDispo = (tn) => c.variantes.some((v) => v.options[c.idxTaille] === tn && v.available);

        /* Format (2x6/4x4/5x5) : désactivé seul si aucune longueur n'est disponible pour ce format. */
        radiosTaille.forEach((r) => { r.disabled = !tailleDispo(r.value); });
        const dispoTaille = radiosTaille.filter((r) => !r.disabled);
        if (dispoTaille.length && !dispoTaille.some((r) => r.checked)) dispoTaille[0].checked = true;
        taille = this.taille;

        /* Longueur de closure : épuisée pour le format choisi -> désactivée, mention « Épuisé ». */
        radiosLongueur.forEach((r) => {
          const v = this.variantClosure(taille, num(r.value)), ok = !!(v && v.available);
          r.disabled = !ok; r.toggleAttribute('data-epuise', !ok);
          const span = r.nextElementSibling, small = span && $(span, 'small');
          if (!ok && span && !small) span.insertAdjacentHTML('beforeend', `<small>${esc(t.epuise)}</small>`);
          if (ok && small) small.remove();
        });
        const dispoLongueur = radiosLongueur.filter((r) => !r.disabled);
        if (dispoLongueur.length && !dispoLongueur.some((r) => r.checked)) {
          /* Recommandation épuisée pour ce format : la plus grande longueur disponible ≤ cible,
             sinon la plus petite disponible. Le texte « Closure conseillée » garde la cible d'origine. */
          const cible = this.closureCible(l);
          let meilleur = null;
          dispoLongueur.forEach((r) => { if (num(r.value) <= cible && (!meilleur || num(r.value) > num(meilleur.value))) meilleur = r; });
          if (!meilleur) meilleur = dispoLongueur.reduce((a, r) => (!a || num(r.value) < num(a.value) ? r : a), null);
          if (meilleur) meilleur.checked = true;
        }
        closureLongueur = this.closureLongueur;

        radiosTaille.forEach((r) => {
          const span = r.nextElementSibling, prixEl = span && $(span, '[data-hm-format-prix]');
          if (!prixEl) return;
          const v = this.variantClosure(r.value, closureLongueur);
          prixEl.textContent = v ? this.money(num(v.price)) : t.epuise;
        });

        cv = dispoTaille.length ? this.variantClosure(taille, closureLongueur) : null;
        const cvDefaut = cv || (dispoTaille[0] && this.variantClosure(dispoTaille[0].value, closureLongueur));
        prixClosure = this.ferme && cv ? num(cv.price) : 0;
        this.el['closure-options'].hidden = !this.ferme;
        this.el['closure-prix-choix'].textContent = cvDefaut ? tpl(t.fermePrix, { montant: this.money(num(cvDefaut.price)) }) : t.epuise;
        const closureReco = this.closureCible(l);
        if (this.el['aide-closure-valeur']) this.el['aide-closure-valeur'].textContent = tpl(t.aideClosureValeur, { closure: closureReco });
        if (this.el['aide-closure-suite']) this.el['aide-closure-suite'].textContent = tpl(t.aideClosureSuite, { longueur: l });
        if (this.ajusterAideClosure) this.ajusterAideClosure();
        radiosLongueur.forEach((r) => {
          const puce = r.closest('.hm-puce');
          if (puce) puce.classList.toggle('is-reco', num(r.value) === closureReco);
        });
        /* « Fermé » n'est désactivé que si aucune variante de closure n'est disponible du tout. */
        this.el.ferme.disabled = !c.variantes.some((v) => v.available);
        if (this.el.ferme.disabled && this.el.ferme.checked) { $(this, 'input[name="hm-type"][value="ouvert"]').checked = true; }
        this.majSchemaLace(taille);
      }
      this.cv = this.ferme ? cv : null;

      /* Totaux, badge, bouton, récapitulatif */
      const prixMeches = vmSel ? vmSel.prix : 0;
      const prixBarreMeches = vmSel ? vmSel.prixBarre : 0;
      const eco = prixBarreMeches > prixMeches ? prixBarreMeches - prixMeches : 0;
      const prixBarreTotal = eco > 0 ? prixBarreMeches + prixClosure : 0;
      const surCommande = !!(vmSel && vmSel.surCommande);
      const total = prixMeches + prixClosure;
      const epuise = !li || li.hasAttribute('data-epuise') || !vmSel || !vmSel.disponible || (this.ferme && (!cv || !cv.available));
      if (this.el.dispo) this.el.dispo.hidden = epuise;
      if (this.el['dispo-epuise']) { this.el['dispo-epuise'].hidden = !epuise; this.el['dispo-epuise'].textContent = epuise ? t.epuiseSelection : ''; }
      this.majStatut(surCommande);
      const taux = (window.Shopify && window.Shopify.currency && num(window.Shopify.currency.rate)) || 1;
      const manque = Math.round(this.r.seuil * taux) - total;
      this.el.badge.classList.toggle('is-incitation', manque > 0);
      this.el['badge-texte'].textContent = manque > 0 ? tpl(t.badgeSous, { montant: this.money(manque) }) : t.badgeOfferte;
      if (this.el.eco) this.el.eco.hidden = !(eco > 0);
      if (this.el['eco-texte']) this.el['eco-texte'].textContent = eco > 0 ? tpl(t.pastilleEconomie, { economie: this.money(eco) }) : '';
      this.el['cta-prix'].innerHTML = this.cardPrixHtml(total, prixBarreTotal);
      this.el.echeances.innerHTML = this.echeancesHtml(this.money(Math.round(total / num(this.r.echeances))));
      const vars = { quantite: qte, paquet: this.mot(qte), longueur: l, taille, montant: this.money(total) };
      const recapTexte = String(t.recapPrefixe ?? '').replace(/\s+$/, '') + ' ' + tpl(t.recap, vars) + (this.ferme && cv ? ' ' + tpl(t.recapClosure, vars) : '');
      if (this.el.collante) {
        this.el['collante-prix'].innerHTML = this.cardPrixHtml(total, prixBarreTotal);
        this.el['collante-detail'].textContent = tpl(t.collanteDetail, vars) + (this.ferme && cv ? ' ' + t.collanteClosure : '');
        if (this.el['collante-eco']) this.el['collante-eco'].hidden = !(eco > 0);
        if (this.el['collante-eco-texte']) this.el['collante-eco-texte'].textContent = eco > 0 ? tpl(t.pastilleEconomie, { economie: this.money(eco) }) : '';
      }
      this.el.id.value = vmSel ? vmSel.id : this.el.id.value;
      this.el.cta.disabled = epuise;
      this.el['cta-texte'].textContent = epuise ? t.boutonEpuise : t.bouton;
      if (this.el['collante-btn']) this.el['collante-btn'].disabled = epuise;
      if (this.el['collante-texte']) this.el['collante-texte'].textContent = epuise ? t.boutonEpuise : t.bouton;

      /* Guide des paquets (ligne en surbrillance, étiquette, bouton d'ajout + récapitulatif) */
      $$(document, '[data-hm-guide-ligne]').forEach((tr) => {
        const actif = !!l && l >= num(tr.dataset.min) && l <= num(tr.dataset.max);
        tr.classList.toggle('is-active', actif);
        const etq = tr.querySelector('[data-hm-guide-etiquette]');
        if (etq) etq.textContent = actif ? t.guideEtiquette : '';
      });
      const guideCta = $(document, '[data-hm-guide-cta]');
      if (guideCta) {
        guideCta.disabled = epuise;
        guideCta.querySelector('[data-hm-guide-cta-texte]').textContent = epuise ? t.boutonEpuise : t.guideBouton;
        const guidePrix = guideCta.querySelector('[data-hm-guide-cta-prix]');
        if (guidePrix) guidePrix.textContent = epuise ? '' : this.money(total);
      }
      const guideRecap = $(document, '[data-hm-guide-recap]');
      if (guideRecap) guideRecap.textContent = epuise ? '' : recapTexte;
      const guideEcheances = $(document, '[data-hm-guide-echeances]');
      if (guideEcheances) guideEcheances.textContent = epuise ? '' : this.el.echeances.textContent;
    }

    /* ---------- Schéma de la taille de lace ---------- */
    majSchemaLace(taille) {
      if (!this.schemaClosure) return;
      this.schemaClosure.afficher(taille);
      const dim = $(this.el.lace, '[data-hm-lace-dim]'), d = window.HMIllustrations.SchemaClosure.dimensions(taille);
      if (dim) dim.textContent = tpl(this.t.laceSchemaDim, { largeur: d.l, profondeur: d.p });
    }

    /* ---------- Dates de livraison ---------- */
    dates() {
      const t = this.t, r = this.r, loc = r.locale || 'fr';
      /* Délai : celui de la table de assets/hm-livraison.js si le produit y figure, sinon celui
         réglé dans le gabarit (closures, frontales… : comportement inchangé). */
      this.dateTexte = window.HMLivraison.dateTexte(window.HMLivraison.delai(this.d.handle, [], num(r.delai)), loc);
      $$(document, '[data-hm-dates]').forEach((n) => { n.textContent = tpl(t.dates, { date: this.dateTexte }); });
    }

    /* ---------- Ligne de statut : texte et point de couleur décidés par assets/hm-livraison.js
       (règle unique : un produit à délai fixe n'est jamais « sur commande ») ---------- */
    majStatut(surCommande) {
      const ligne = window.HMLivraison.ligneStatut(this.d.handle, surCommande, this.dateTexte, this.t);
      if (this.el['point-dispo']) this.el['point-dispo'].classList.toggle('est-attente', ligne.attente);
      if (this.el['dispo-texte']) this.el['dispo-texte'].innerHTML = ligne.html;
    }

    /* ---------- Prix du bouton d'achat : prix seul, ou prix barré + prix payé ---------- */
    cardPrixHtml(total, prixBarre) {
      if (prixBarre > total) {
        return `<span class="hm-cta__duo"><span class="hm-cta__barre">${this.money(prixBarre)}</span><span class="hm-cta__net">${this.money(total)}</span></span>`;
      }
      return this.money(total);
    }

    /* ---------- Paiement en plusieurs fois : seul le premier mot (« ou ») reste en secondaire ---------- */
    echeancesHtml(montant) {
      const texte = String(this.t.echeances ?? '').replace('[montant]', montant);
      const espace = texte.indexOf(' ');
      if (espace === -1) return `<b>${esc(texte)}</b>`;
      return `${esc(texte.slice(0, espace))} <b>${esc(texte.slice(espace + 1))}</b>`;
    }

    /* ---------- Galerie : points, vignettes, flèches et vidéos ---------- */
    galerie() {
      const piste = this.el.piste, zone = this.el.points, vignettes = this.el.vignettes;
      if (!piste) return;
      const medias = $$(piste, '[data-hm-media]');
      const pts = zone ? $$(zone, '[data-hm-point]') : [];
      const vigs = vignettes ? $$(vignettes, '[data-hm-vignette]') : [];
      const aller = (i) => piste.scrollTo({ left: medias[i].offsetLeft, behavior: 'smooth' });
      pts.forEach((b, i) => b.addEventListener('click', () => aller(i)));
      vigs.forEach((b, i) => b.addEventListener('click', () => aller(i)));
      const fleches = $$(this, '[data-hm-fleche]');
      fleches.forEach((b) => b.addEventListener('click', () => {
        const i = Math.round(piste.scrollLeft / piste.clientWidth);
        const suivant = b.dataset.hmFleche === 'suiv';
        const cible = Math.min(Math.max(suivant ? i + 1 : i - 1, 0), medias.length - 1);
        aller(cible);
      }));
      const videos = this.initVideosGalerie(medias);
      let attente = false;
      const maj = () => {
        attente = false;
        const i = Math.round(piste.scrollLeft / piste.clientWidth);
        pts.forEach((b, k) => b.setAttribute('aria-current', k === i));
        vigs.forEach((b, k) => b.setAttribute('aria-current', k === i));
        fleches.forEach((b) => { b.disabled = b.dataset.hmFleche === 'prec' ? i === 0 : i === medias.length - 1; });
        videos.actualiser(i);
      };
      piste.addEventListener('scroll', () => { if (!attente) { attente = true; requestAnimationFrame(maj); } }, { passive: true });
      maj();
    }

    /* ---------- Vidéos de la galerie ----------
       Lecture automatique muette en boucle, uniquement quand la diapositive est active ET visible
       à l'écran (IntersectionObserver). Un bouton lecture/pause toujours visible en bas à droite
       (snippets/hm-video-bouton.liquid, identique à celui du bandeau vidéo de collection) la met
       en pause ou la relance (aucune reprise automatique tant que la cliente l'a mise en pause
       elle-même). Son icône reflète l'état réel de la vidéo, y compris quand la lecture automatique
       est refusée (iOS, mode économie d'énergie) : voir majBouton()/jouer() ci-dessous. Rien n'est
       chargé avant que la diapositive devienne active. Avec prefers-reduced-motion : aucune lecture
       automatique, seul le bouton démarre la vidéo (une fois démarrée par la cliente, les
       pauses/reprises liées au changement de diapositive restent actives). */
    initVideosGalerie(medias) {
      const reduitMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const items = medias.map((fig, index) => {
        const natif = $(fig, '.hm-galerie__video');
        const externe = $(fig, '[data-hm-video-externe]');
        const bouton = $(fig, '[data-hm-video-bouton]');
        if (!bouton || (!natif && !externe)) return null;
        return { index, fig, natif, externe, bouton, visible: false, active: false, pausee: false, demarree: false, chargee: false, enLecture: false };
      }).filter(Boolean);
      if (!items.length) return { actualiser() {} };

      const majBouton = (v) => {
        const enLecture = v.natif ? !v.natif.paused : v.enLecture;
        v.bouton.setAttribute('data-hm-en-lecture', String(enLecture));
        v.bouton.setAttribute('aria-label', enLecture ? this.t.videoPauseLabel : this.t.videoLireLabel);
      };
      const charger = (v) => {
        if (v.chargee || !v.externe) return;
        v.chargee = true;
        const host = v.externe.dataset.hmHost, id = v.externe.dataset.hmId;
        const src = host === 'vimeo'
          ? `https://player.vimeo.com/video/${id}?autoplay=1&muted=1&loop=1&controls=0&playsinline=1&background=0`
          : `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&playsinline=1&rel=0&modestbranding=1&fs=0&iv_load_policy=3&enablejsapi=1`;
        const iframe = document.createElement('iframe');
        iframe.className = 'hm-galerie__video-iframe';
        iframe.src = src;
        iframe.allow = 'autoplay; encrypted-media';
        iframe.setAttribute('title', $(v.externe, 'img')?.alt || '');
        v.externe.appendChild(iframe);
        v.iframe = iframe;
      };
      const commande = (v, action) => {
        if (!v.iframe) return;
        const msg = v.externe.dataset.hmHost === 'vimeo'
          ? { method: action === 'play' ? 'play' : 'pause' }
          : { event: 'command', func: action === 'play' ? 'playVideo' : 'pauseVideo', args: [] };
        v.iframe.contentWindow.postMessage(JSON.stringify(msg), '*');
      };
      const chargerNatif = (v) => {
        if (v.chargee || !v.natif) return;
        v.chargee = true;
        let sources = [];
        try { sources = JSON.parse(v.natif.dataset.hmVideoSources || '[]'); } catch (err) { sources = []; }
        const rect = v.natif.getBoundingClientRect();
        const choisie = choisirSourceMp4(sources, rect.height || v.natif.clientHeight);
        if (choisie) {
          const source = document.createElement('source');
          source.src = choisie.url;
          if (choisie.type) source.type = choisie.type;
          v.natif.appendChild(source);
          v.natif.load();
        }
      };
      const jouer = (v) => {
        if (v.natif) {
          if (!v.chargee) chargerNatif(v);
          /* Ne jamais supposer que la lecture a demarre : iOS (mode economie d'energie) peut
             rejeter play() sans jamais lancer la video. Le bouton n'est mis a jour qu'une fois
             la promesse tranchee, dans un sens comme dans l'autre, sur l'etat reel (v.natif.paused). */
          const p = v.natif.play();
          if (p && p.then) p.then(() => majBouton(v)).catch(() => majBouton(v));
          else majBouton(v);
        } else {
          v.enLecture = true;
          if (!v.chargee) charger(v); else commande(v, 'play');
          majBouton(v);
        }
      };
      const pauser = (v) => {
        if (v.natif) v.natif.pause();
        else { v.enLecture = false; if (v.chargee) commande(v, 'pause'); }
        majBouton(v);
      };
      const appliquer = () => {
        items.forEach((v) => {
          const doitJouer = v.active && v.visible && !v.pausee && (!reduitMotion || v.demarree);
          if (doitJouer) jouer(v); else pauser(v);
        });
      };

      items.forEach((v) => {
        v.bouton.addEventListener('click', () => {
          const enLecture = v.natif ? !v.natif.paused : v.enLecture;
          if (enLecture) { v.pausee = true; pauser(v); } else { v.pausee = false; v.demarree = true; jouer(v); }
        });
        if (v.natif) {
          v.natif.addEventListener('play', () => majBouton(v));
          v.natif.addEventListener('pause', () => majBouton(v));
        }
        majBouton(v);
      });

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            const v = items.find((x) => x.fig === e.target);
            if (v) v.visible = e.isIntersecting;
          });
          appliquer();
        }, { threshold: 0.5 });
        items.forEach((v) => io.observe(v.fig));
      } else {
        items.forEach((v) => { v.visible = true; });
      }

      return {
        actualiser(indexActif) {
          items.forEach((v) => { v.active = v.index === indexActif; });
          appliquer();
        }
      };
    }

    /* ---------- Étiquettes : taille automatique pour tenir sur une seule ligne ---------- */
    etiquettes() {
      const ul = this.el.tags;
      if (!ul) return;
      const ajuster = () => ajusterTailleEtiquettes(ul);
      if ('ResizeObserver' in window) new ResizeObserver(ajuster).observe(ul);
      else ajuster();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajuster);
      document.addEventListener('shopify:section:load', ajuster);
    }

    /* ---------- Closure conseillée : taille automatique pour tenir sur une seule ligne ---------- */
    closureConseillee() {
      const p = this.el['aide-longueur-closure'];
      if (!p) return;
      this.ajusterAideClosure = () => ajusterTailleClosure(p);
      if ('ResizeObserver' in window) new ResizeObserver(this.ajusterAideClosure).observe(p);
      else this.ajusterAideClosure();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.ajusterAideClosure);
      document.addEventListener('shopify:section:load', this.ajusterAideClosure);
    }

    /* ---------- Barre d'achat collante ---------- */
    collante() {
      const barre = this.el.collante, btn = this.el['collante-btn'], cta = this.el.cta;
      if (!barre || !btn || !cta || !('IntersectionObserver' in window)) return;
      const pied = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('main > footer, body > footer');
      const racineDoc = document.documentElement;
      let piedVisible = false, attente = false;
      /* Bulle de chat (Zipchat, shadow DOM ouvert) : remontée au-dessus de la barre quand celle-ci est visible,
         par une marge basse, jamais par un transform (un transform sur le conteneur déplacerait son message,
         en position fixe, au milieu de la page et écraserait le transform que Zipchat utilise pour l'afficher
         ou le masquer). Son message est replacé pour garder 20 px (écart de Zipchat) au-dessus de la bulle,
         que la barre apparaisse avant ou après lui ; recalculé quand Zipchat l'affiche ou le déplace. */
      let leveeChat = 0, suiviMessage = null;
      const placerChat = () => {
        const sr = document.querySelector('#zipchat-shadow-host')?.shadowRoot;
        if (!sr) return;
        const cont = sr.getElementById('widget-chat-container');
        const msg = sr.getElementById('chat-preview-message');
        if (cont) {
          const mb = leveeChat ? `${leveeChat}px` : '';
          if (cont.style.marginBottom !== mb) cont.style.marginBottom = mb;
        }
        if (!cont || !msg) return;
        if (!suiviMessage && 'MutationObserver' in window) {
          suiviMessage = new MutationObserver(placerChat);
          suiviMessage.observe(msg, { attributes: true, attributeFilter: ['style'] });
        }
        const mCour = parseFloat(msg.style.marginBottom) || 0;
        const r = msg.getBoundingClientRect();
        let m = 0;
        if (r.height > 0) {
          const hautBulle = window.innerHeight - (parseFloat(getComputedStyle(cont).bottom) || 0) - leveeChat - cont.offsetHeight;
          /* Positive : remonte le message ; négative : le redescend (barre masquée après son affichage). */
          m = Math.round(r.bottom + mCour - (hautBulle - 20));
        }
        const mVoulu = m ? `${m}px` : '';
        if (msg.style.marginBottom !== mVoulu) msg.style.marginBottom = mVoulu;
      };
      const appliquer = () => {
        attente = false;
        /* Position et ligne de reference relues ici, au moment de l'application, plutot que figees
           dans l'entree d'un observateur : un IntersectionObserver ne notifie que lorsque le bouton
           franchit un seuil de visibilite (0 % <-> visible). Une mise en page qui change de hauteur
           sans faire franchir ce seuil (police qui charge, contenu qui se met a jour ailleurs sur la
           page) ne redeclenche pas l'observateur ; s'appuyer sur l'entree fournie exposerait a une
           lecture perimee, notamment sur les colonnes larges du bureau ou beaucoup de texte precede
           le bouton. Ligne de reference = bas de la zone collante du site (en-tete + barre d'annonce),
           deja exposee en pixels via scroll-padding-top (assets/theme.css). */
        const ligne = parseFloat(getComputedStyle(racineDoc).scrollPaddingTop) || 0;
        const passe = cta.getBoundingClientRect().bottom < ligne;
        const v = passe && !piedVisible;
        barre.classList.toggle('is-visible', v); barre.setAttribute('aria-hidden', String(!v)); btn.tabIndex = v ? 0 : -1;
        leveeChat = v ? barre.offsetHeight + 12 : 0;
        placerChat();
      };
      const programmer = () => { if (!attente) { attente = true; requestAnimationFrame(appliquer); } };
      /* Position reelle du bouton (IntersectionObserver), pas un seuil de defilement en pixels : se
         declenche uniquement quand le bouton entre ou sort du viewport. */
      new IntersectionObserver(programmer).observe(cta);
      if (pied) new IntersectionObserver(([e]) => { piedVisible = e.isIntersecting; programmer(); }).observe(pied);
      /* Filet de securite : tout changement de mise en page qui ne fait pas franchir de seuil au
         bouton (police qui charge, contenu mis a jour) doit quand meme redeclencher une verification. */
      if ('ResizeObserver' in window) new ResizeObserver(programmer).observe(document.body);
      /* Defilement : ecoute passive, en complement des observateurs et non a leur place. L'observateur
         ci-dessus ne notifie qu'au franchissement du 0 % de visibilite du bouton, alors que la decision
         se prend sur `ligne` (54 px sur iPhone). Entre ces deux reperes existe une bande ou le bouton
         est revenu a l'ecran sans qu'aucun seuil n'ait ete franchi : la barre y restait affichee juste
         sous lui, et rien ne la corrigeait tant que le bouton ne ressortait pas. Safari iOS differe en
         outre ces notifications pendant le defilement par inertie, d'ou la coexistence des deux boutons
         jusqu'a l'arret. `programmer` coalesce deja a une evaluation par frame : l'ecoute ne coute pas
         plus qu'un rafraichissement d'animation. */
      window.addEventListener('scroll', programmer, { passive: true });
      window.addEventListener('resize', programmer);
      window.addEventListener('hashchange', programmer);
      const tiroir = document.getElementById('cart-drawer');
      if (tiroir) { tiroir.addEventListener('dialog:after-show', programmer); tiroir.addEventListener('dialog:after-hide', programmer); }
      programmer();
    }

    /* ---------- Ajout au panier ---------- */
    async onSubmit(e) {
      e.preventDefault();
      const cta = this.el.cta, t = this.t, root = racine();
      if (cta.getAttribute('aria-busy') === 'true' || cta.disabled) return;
      const vm = this.r.modeClosure ? this.vSelClosure : this.variantMeches(this.longueur, this.qte);
      if (!vm) return;
      const items = [{ id: vm.id, quantity: 1 }];
      if (this.cv) items.push({ id: num(this.cv.id), quantity: 1 });
      const boutons = [cta, this.el['collante-btn']].filter(Boolean);
      boutons.forEach((b) => b.setAttribute('aria-busy', 'true'));
      this.el['cta-texte'].textContent = t.boutonChargement;
      this.el.erreur.hidden = true;
      emit('theme:loading:start');
      const sections = [];
      emit('cart:prepare-bundled-sections', { sections });
      let res, json;
      try {
        res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: sections.join(',') })
        });
        json = await res.json();
      } catch (err) {
        res = { ok: false }; json = { description: '' };
      }
      emit('theme:loading:end');
      boutons.forEach((b) => b.removeAttribute('aria-busy'));
      this.el['cta-texte'].textContent = t.bouton;
      if (res.ok) {
        const cartType = window.themeVariables && window.themeVariables.settings.cartType;
        if (cartType === 'page') { location.href = `${root}cart`; return; }
        /* Relecture du panier. L'ajout est déjà validé côté Shopify : cet appel ne sert qu'à
           obtenir l'état complet (item_count) et le HTML du tiroir. Quand il échouait — coupure
           réseau entre les deux requêtes, ou réponse non JSON, ce second appel ne contrôlant
           pas res.ok —, l'exception partait dans le vide : ni tiroir, ni compteur, ni message,
           alors que l'article était bien au panier. La cliente recommençait et ajoutait deux
           fois. On se rabat désormais sur cart:refresh, que le thème traite en rechargeant
           compteur, pastille et contenu du tiroir depuis le serveur. Le tiroir ne s'ouvre pas
           dans ce cas : refreshCart se contente de remplacer son contenu. */
        let cart;
        try {
          cart = await (await fetch(`${root}cart.js`)).json();
        } catch (err) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }
        cart.sections = json.sections;
        this.form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [json], cart } }));
        emit('cart:change', { baseEvent: 'variant:add', cart });
      } else {
        this.el.erreur.innerHTML = esc(t.erreur) + (json.description ? `<small>${esc(json.description)}</small>` : '');
        this.el.erreur.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        /* Signale l'échec sur le formulaire. Cet événement ne libère plus rien : le verrou
           anti-double-envoi de component-hm-buy.js, qui l'écoutait, n'est plus chargé. Le nôtre
           est déjà levé plus haut, hors de toute condition. Aucun auditeur sur ces fiches —
           le <buy-buttons> de Prestige, seul autre écouteur du thème, n'y est pas rendu. Conservé
           comme point d'accroche pour un tiers ou une section future. */
        this.form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: json.description } }));
      }
    }
  }

  window.customElements.define('hm-produit', HmProduit);
})();
